import React from 'react';
import PropTypes from 'prop-types';
import { lookupsJson } from '@ourbranch/lookups';

import Field from 'core/components/form/form.v2';
import { LabelTooltip } from 'core/components/label-tooltip';

// Form options constants
const bqOptions = lookupsJson.farm.buildingQuality;

const HoopBuildingFields = ({
  fieldName,
  initialBuilding,
  disableRiskForm,
  currentHeatingOptions,
  isSelectedHeatingSourceUnitCountBased,
  toastRCEWarning,
  ctOptions
}) => {
  return (
    <>
      <Field
        xs={6}
        type="numeric"
        id={`${fieldName}.building.yearBuilt`}
        name={`${fieldName}.building.yearBuilt`}
        mode="light"
        label="Year built in"
        format={{
          allowNegative: false
        }}
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.yearBuilt) {
            toastRCEWarning();
          }
        }}
      />
      <Field
        xs={6}
        type="numeric"
        id={`${fieldName}.building.roofYear`}
        name={`${fieldName}.building.roofYear`}
        mode="light"
        label="Roof year"
        format={{
          allowNegative: false
        }}
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.roofYear) {
            toastRCEWarning();
          }
        }}
      />
      <Field
        xs={6}
        type="numeric"
        id={`${fieldName}.building.sqFt`}
        name={`${fieldName}.building.sqFt`}
        mode="light"
        label="Total sqft"
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.sqFt) {
            toastRCEWarning();
          }
        }}
      />
      <Field
        xs={6}
        type="select"
        id={`${fieldName}.building.buildingQuality`}
        name={`${fieldName}.building.buildingQuality`}
        mode="light"
        label="Quality"
        options={bqOptions}
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.buildingQuality) {
            toastRCEWarning();
          }
        }}
      />
      <Field
        xs={6}
        type="select"
        id={`${fieldName}.building.roofType`}
        name={`${fieldName}.building.roofType`}
        mode="light"
        label="Roof type"
        options={[{ id: 'HOOP', value: 'Hoop' }]}
        disabled={true}
        helperText="Roof type included in Hoop Building construction"
        onChange={(val) => {
          if (val !== initialBuilding?.roofType) {
            toastRCEWarning();
          }
        }}
      />
      <Field
        xs={6}
        type="select"
        id={`${fieldName}.building.constructionType`}
        name={`${fieldName}.building.constructionType`}
        mode="light"
        label="Construction type"
        options={ctOptions}
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.constructionType) {
            toastRCEWarning();
          }
        }}
      />
      {/* Hoop Building Type field removed - occupancy is now automatically set to 'HP' */}
      <LabelTooltip
        label="Number of solid fuel burning..."
        tooltip={{
          label: 'More Info',
          onHoverText: `Count appliances that burn fuel like gas, propane, oil, or wood. Common examples: furnace, boiler, water heater, fireplace, wood stove, gas oven, gas dryer, or backup generators. Electric-only appliances don't count.`
        }}
        mode="light"
      >
        <Field
          xs={6}
          type="numeric"
          id={`${fieldName}.building.numSolidFuelBurningAppliances`}
          name={`${fieldName}.building.numSolidFuelBurningAppliances`}
          mode="light"
          disabled={disableRiskForm}
          format={{
            allowNegative: false
          }}
          onChange={(val) => {
            if (val !== initialBuilding?.numSolidFuelBurningAppliances) {
              toastRCEWarning();
            }
          }}
        />
      </LabelTooltip>
      <Field
        xs={6}
        type="select"
        id={`${fieldName}.building.primaryHeatingSource`}
        name={`${fieldName}.building.primaryHeatingSource`}
        mode="light"
        label="Primary heating"
        options={currentHeatingOptions}
        disabled={disableRiskForm}
        onChange={(val) => {
          if (val !== initialBuilding?.primaryHeatingSource) {
            toastRCEWarning();
          }
        }}
      />
      <Field
        xs={6}
        type="numeric"
        id={`${fieldName}.building.numHeatingSources`}
        name={`${fieldName}.building.numHeatingSources`}
        mode="light"
        label="Heating units"
        disabled={disableRiskForm || !isSelectedHeatingSourceUnitCountBased}
        helperText="Acceptable range: 1-1000"
        onChange={(val) => {
          if (val !== initialBuilding?.numHeatingSources) {
            toastRCEWarning();
          }
        }}
      />
    </>
  );
};

HoopBuildingFields.propTypes = {
  fieldName: PropTypes.string.isRequired,
  initialBuilding: PropTypes.object.isRequired,
  disableRiskForm: PropTypes.bool.isRequired,
  currentHeatingOptions: PropTypes.array.isRequired,
  isSelectedHeatingSourceUnitCountBased: PropTypes.bool.isRequired,
  toastRCEWarning: PropTypes.func.isRequired,
  ctOptions: PropTypes.array.isRequired
};

export default HoopBuildingFields;
